import React, { useState, useEffect } from 'react';
import { Box, Typography, useTheme } from '@mui/material';

interface TabsProps {
  tabs: { label: string; content: React.ReactNode }[];
  initialTab?: number;
  activeTab?: number;
  onChange?: (index: number) => void;
  contrast?: boolean;
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  initialTab = 0,
  activeTab,
  onChange,
  contrast = true,
}) => {
  const theme = useTheme();
  const [internalActiveTab, setInternalActiveTab] = useState(initialTab);

  const currentActiveTab = activeTab !== undefined ? activeTab : internalActiveTab;

  useEffect(() => {
    if (activeTab !== undefined) {
      setInternalActiveTab(activeTab);
    }
  }, [activeTab]);

  const handleTabClick = (index: number) => {
    if (activeTab === undefined) {
      setInternalActiveTab(index);
    }
    if (onChange) {
      onChange(index);
    }
  };

  return (
    <Box
      sx={{
        borderRadius: 4,
        backgroundColor: '#F2F4F7',
        p: 1,
        width: '100%',
        direction: 'rtl',
        boxSizing: 'border-box',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          direction: 'rtl',
          gap: '5px',
        }}
      >
        {tabs.map((tab, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              textAlign: 'center',
              cursor: 'pointer',
              borderRadius: 4,
              backgroundColor: index === currentActiveTab ? '#343434' : 'transparent',
              color:
                index === currentActiveTab ? '#C1FE40' : theme.palette.text.primary,
              transition: 'background-color 0.3s, color 0.3s',
              px: '8px',
              py: '10px',
            }}
            onClick={() => handleTabClick(index)}
          >
            <Typography
              variant="body1"
              sx={{
                fontFamily: 'AlmoniDL',
                fontWeight: 700,
              }}
            >
              {tab.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Tabs;
